import { PropsWithChildren } from "react";
import ApiReference from "../../content/en/api-reference/_index";
import Datasheets from "../../content/en/datasheets/_index";
import Docs from "../../content/en/docs/_index";
import GuidesAndTutorials from "../../content/en/guides-and-tutorials/_index";
import LoRa from "../../content/en/lora/_index";
import FeatherMCUs from "../../content/en/feather-mcus/_index";
import Starnote from "../../content/en/starnote/_index";
import Notecard from "../../content/en/notecard/_index";
import Notehub from "../../content/en/notehub/_index";
import Quickstart from "../../content/en/quickstart/_index";
import ToolsAndSDKs from "../../content/en/tools-and-sdks/_index";
import ExampleApps from "../../content/en/example-apps/_index";

type LandingPage = {
  component: (a: any) => JSX.Element;
  description: string;
};

type LandingPagesType = {
  [name: string]: LandingPage;
};

const SearchEngineH1 = ({ children }: PropsWithChildren) => (
  <h1 style={{ visibility: "hidden" }}>{children}</h1>
);

const LandingPages: LandingPagesType = {
  "api-reference": {
    component: ApiReference,
    description:
      "Comprehensive reference documentation for Blues developer APIs",
  },
  datasheets: {
    component: Datasheets,
    description:
      "Datasheets, design files, and resources for building your own Notecarriers.",
  },
  docs: {
    component: Docs,
    description:
      "Welcome to Blues! We're helping you solve the problem of wireless connectivity, once and for all.",
  },
  "guides-and-tutorials": {
    component: GuidesAndTutorials,
    description:
      "Guides & tutorials for learning Blues hardware and cloud services.",
  },
  lora: {
    component: LoRa,
    description:
      "The hub for documentation on building LoRa-based solutions with Blues.",
  },
  starnote: {
    component: Starnote,
    description:
      "The hub for documentation on building Notecard solutions that use Starnote for satellite data transmission.",
  },
  "feather-mcus": {
    component: FeatherMCUs,
    description: "The hub for documentation on Blues Cygnet and Blues Swan.",
  },
  notecard: {
    component: Notecard,
    description: "The hub for documentation on Notecard.",
  },
  notehub: {
    component: Notehub,
    description: "The hub for documentation on Notehub.",
  },
  quickstart: {
    component: Quickstart,
    description:
      "Tutorials to help you get up and running with Blues hardware fast.",
  },
  terminal: {
    component: () => <SearchEngineH1>In-Browser Terminal</SearchEngineH1>,
    description:
      "An in-browser terminal for interacting with Notecard devices.",
  },
  "tools-and-sdks": {
    component: ToolsAndSDKs,
    description:
      "Accelerate your development with command-line tools, firmware libraries, and a collection of host MCU samples.",
  },
  "example-apps": {
    component: ExampleApps,
    description:
      "Blues provides a variety of open source example applications, code snippets, and best practices to help you build your connected product.",
  },
};

// Determine the type of menu a given landing page should use. The “main”
// menu shows all top-level menu options, and the “galaxy” menu shows only
// sub-menu options from within a single galaxy. Needed to make docs landing page
// display the main menu, and all other landing pages display the galaxy menu.
export function determineMenuType(landingPage: string) {
  return ["docs"].includes(landingPage) ? "main" : "galaxy";
}

export default LandingPages;
